import React from 'react';
import { TableCell, TableCellProps } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export type DataGridCellProps = TableCellProps & {
  ref?: React.RefObject<HTMLTableRowElement | HTMLTableCellElement>;
}

// Hack around propTypes breaking generic interfaces
type DataGridCellComponent = {
  (props: DataGridCellProps): React.JSX.Element;
  // eslint-disable-next-line @typescript-eslint/ban-types
  propTypes?: {};
  displayName: string;
};

// Ugly hack to merge classNames with base TableCell
export const DataGridCell: DataGridCellComponent = (props: DataGridCellProps) => {
  const { className, component, ...rest } = props;

  return (
    <TableCell
      ref={props.ref}
      {...rest}
      component={(_props) => <TableCell {..._props} component={component} className={classNames(_props.className, className)} />}
    />
  );
};

DataGridCell.propTypes = {
  className: PropTypes.string,
  // @ts-ignore
  component: PropTypes.elementType
// Typescript overrides types for props when types include a generic interface and propTypes are passed
// eslint-disable-next-line @typescript-eslint/ban-types
} as {};

DataGridCell.displayName = 'DataGridCell';
